import { Stack } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { StyledButton } from './styles';
import { ActionTableButtonProps } from './types';

const ActionTableButton = ({ action }: ActionTableButtonProps) => {
  return (
    <Stack flexDirection={'row'} justifyContent={'flex-end'} width={'100%'}>
      <StyledButton onClick={action}>
        <Icon
          name="actions-b2b-expand-circle-right"
          color={NEW_COLORS.PRIMARY[500]}
        />
      </StyledButton>
    </Stack>
  );
};

export default ActionTableButton;
